<ng-container *ngIf="mainObject && mainObject.mainObject">
    <mvs-smart-widget-chip
            [header]="mainObject?.objectDto?.name"
            [label]="mainObject?.objectDto ? mainObject?.objectDto?.['alias'] : mainObject.objectId"
            [object]="mainObject"
            (onObjectSelect)="openObjectDrawer(mainObject)"
            (onObjectRemove)="removeActiveMainObject(mainObject)"
    ></mvs-smart-widget-chip>
</ng-container>